import React from "react";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { generatePdf, isNullOrEmpty } from "../utils";
import "jspdf-autotable";

const HttpClient = () => {
  const HandleLoginApi = async ({ staffCode, password }, success, fail) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN_PATH}/auth/login`,
        {
          staffCode,
          password,
        }
      );
      const data = response.data;
      if (!!data) {
        localStorage.setItem("user", JSON.stringify(data));
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const FetchExternalLink = async ({ brand }, success, fail) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN_PATH}/links`,
        {
          brand: brand,
          domain: `${process.env.REACT_APP_ROUTE_DOMAIN_PATH}`
        }
      );
      const data = response.data;
      if (!!data) {
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const HandleSearchStaffApi = async ({ searchValue, userDataFilter }, success, fail) => {
    userDataFilter = userDataFilter?.filter(
      (o) => o.controlArea === "recruitment" || o.controlArea === "c&b"
    );

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/search`,
        {
          params: {
            value: searchValue,
            userDataFilter: JSON.stringify(userDataFilter),
          },
        }
      );
      const data = response.data;

      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const HandleWebSearchStaffApi = async ({ searchValue, userDataFilter }, success, fail) => {
    userDataFilter = userDataFilter?.filter(
      (o) => o.controlArea === "recruitment" || o.controlArea === "c&b"
    );

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/web-search`,
        {
          params: {
            value: searchValue,
            userDataFilter: JSON.stringify(userDataFilter),
          },
        }
      );
      const data = response.data;

      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const HandleIpadSearchStaffApi = async ({ searchValue, userDataFilter }, success, fail) => {
    userDataFilter = userDataFilter?.filter(
      (o) => o.controlArea === "recruitment" || o.controlArea === "c&b"
    );

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/ipad-search`,
        {
          params: {
            value: searchValue,
            userDataFilter: JSON.stringify(userDataFilter),
          },
        }
      );
      const data = response.data;

      if (!!data?.success) {
        success(data.data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const FetchDocListsApi = async (
    { searchValue, userDataFilter },
    success,
    fail
  ) => {
    userDataFilter = userDataFilter?.filter(
      (o) => o.controlArea === "recruitment" || o.controlArea === "c&b"
    );

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_PATH}/documents`,
        {
          params: {
            value: searchValue,
            userDataFilter: JSON.stringify(userDataFilter),
          },
        }
      );
      const data = response.data;

      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail();
    }
  };

  const UpdateStaffCodeApi = async ({ staffCode, id }, success, fail) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/update-staff-code`,
        {
          staff_code: staffCode,
          id: id,
        }
      );
      const data = response.data;

      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const UpdateStaffJoinDateApi = async ({ staffJoinDate, id }, success, fail) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/update-join-date`,
        {
          joinDate: staffJoinDate,
          id: id,
        }
      );
      const data = response.data;

      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const CheckTokenExpApi = async ({ queryToken }, success, fail) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/verify`,
        {
          params: {
            token: queryToken,
          },
        }
      );
      const data = response.data;

      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail(error);
    }
  };

  const UpdateDocumentApi = async (
    { id, staff_id, staff_signature_date = undefined, signature = undefined, isHrConfirmed = false, signatureImage = undefined },
    success,
    fail
  ) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_DOMAIN_PATH}/documents/update-documents-record`,
        {
          id,
          ...(!!staff_id && { staff_id }),
          ...(!isNullOrEmpty(staff_signature_date) && { staff_signature_date }),
          ...(!isNullOrEmpty(signature) && { signature }),
          ...(!isNullOrEmpty(signatureImage) && { signatureImage }),
          isHrConfirmed,
        }
      );
      const data = response.data;
      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const CreateDocumentApi = async (submitData, success, fail) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN_PATH}/documents/create-documents-record`,
        submitData
      );

      const data = response.data;

      if (!!data?.success) {
        success(data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  const UpdateStaffFormApi = async ({ id, param, onlyUpdateOnce }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/update-staff-records`,
        {
          id,
          ...param,
          onlyUpdateOnce,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      const data = response.data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  const CreateStaffFormApi = async ({ param }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN_PATH}/staffs/create-staff-record`,
        {
          ...param,
        }
      );

      const data = response.data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  const HandleSendEmailApi = async (
    {
      printComponentRef,
      personalRef,
      handBookRef,
      email = "",
      area = "",
      subject = "",
      isFromStaff = false,
    },
    success,
    fail
  ) => {
    try {
      const pdf = new jsPDF("p", "px", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();

      const generateAndLogPdf = async (ref, name) => {
        if (ref?.current) {
          const pdf = await generatePdf(ref, name);
          console.log(`${name} PDF generated:`, pdf);
          return pdf;
        }
        return null;
      };

      const staffPdf = await generateAndLogPdf(printComponentRef, isFromStaff ? 'ReferenceCheckAuthorization' : 'Employee_Personal_Info_Form');
      const personalPdf = await generateAndLogPdf(personalRef, 'Personal_Data_Consent_Form');
      const handBookPdf = await generateAndLogPdf(handBookRef, 'Employee_Handbook_Receipt');

      const generateAndSendPdf = async ({ pdf, filename, email, area, subject }) => {
        const pdfBlob = pdf.output("blob");

        // Provide a download link to the user , for testing
        if (process.env.NODE_ENV === 'development') {
          const url = URL.createObjectURL(pdfBlob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }

        const formData = new FormData();
        formData.append("email", email);
        formData.append("file", pdfBlob, encodeURIComponent(filename));
        formData.append("area", area);
        formData.append("subject", subject);

        await axios.post(
          `${process.env.REACT_APP_DOMAIN_PATH}/email/send`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      };

      // Check if only one PDF exists and return it directly
      if (staffPdf && !personalPdf && !handBookPdf) {
        console.log("Only staff PDF exists, outputting staff PDF directly");
        await generateAndSendPdf({ pdf: staffPdf, filename: isFromStaff ? 'Employee_Personal_Info_Form.pdf' : 'Reference_Check_Authorization.pdf', email, area, subject });
        success();
        return;
      }

      if (!staffPdf && personalPdf && !handBookPdf) {
        console.log("Only personal PDF exists, outputting personal PDF directly");
        await generateAndSendPdf({ pdf: personalPdf, filename: 'Personal_Data_Consent_Form.pdf', email, area, subject });
        success();
        return;
      }

      if (!staffPdf && !personalPdf && handBookPdf) {
        console.log("Only handbook PDF exists, outputting handbook PDF directly");
        await generateAndSendPdf({ pdf: handBookPdf, filename: 'Employee_Handbook_Receipt.pdf', email, area, subject });
        success();
        return;
      }

      // If more than one PDF exists, concatenate them
      const addPagesFromRef = async (ref, targetPdf) => {
        if (!ref.current) {
          console.log("Reference is not available");
          return;
        }
        const canvas = await html2canvas(ref.current, {
          backgroundColor: "#ffffff",
          scale: 2,
          useCORS: true, // Enable cross-origin resource sharing
          ignoreElements: (element) => {
            return element.classList.contains("footerBtn");
          },
        });
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        if (imgWidth === 0 || imgHeight === 0) {
          console.log("Canvas dimensions are zero");
          return;
        }

        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        const pdfWidth = targetPdf.internal.pageSize.getWidth();
        const pdfHeight = targetPdf.internal.pageSize.getHeight();

        const widthRatio = pdfWidth / imgWidth;
        const heightRatio = pdfHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        const finalWidth = imgWidth * ratio;
        const finalHeight = imgHeight * ratio;

        targetPdf.addImage(imgData, "JPEG", 0, 0, finalWidth, finalHeight);

      };

      let isFirstPageAdded = false;

      if (printComponentRef?.current) {
        console.log("Adding pages from printComponentRef");
        await addPagesFromRef(printComponentRef, pdf);
        isFirstPageAdded = true;
        console.log("Pages from printComponentRef added");
      }

      if (personalRef?.current) {
        console.log("Adding pages from personalRef");
        if (isFirstPageAdded) {
          pdf.addPage();
        }
        await addPagesFromRef(personalRef, pdf);
        isFirstPageAdded = true;
        console.log("Pages from personalRef added");
      }

      if (handBookRef?.current) {
        console.log("Adding pages from handBookRef");
        if (isFirstPageAdded) {
          pdf.addPage();
        }
        await addPagesFromRef(handBookRef, pdf);
        console.log("Pages from handBookRef added");
      }

      console.log("Generating final PDF blob");
      await generateAndSendPdf({ pdf, filename: 'Employee_all_info_form.pdf', email, area, subject });

      success();
    } catch (error) {
      console.log("Error in HandleSendEmailApi:", error);
      fail(error?.response?.data?.message);
    }
  };

  const GetStaffSignStatusApi = async ({ id }, success, fail) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMAIN_PATH}/staffs/sign-status`, {
        params: {
          id,
        }
      });
      const data = response.data;
      if (!!data?.success) {
        success(data.data);
      }
    } catch (error) {
      fail(error?.response?.data?.message);
    }
  };

  return {
    HandleLoginApi,
    FetchExternalLink,
    HandleSearchStaffApi,
    HandleWebSearchStaffApi,
    HandleIpadSearchStaffApi,
    FetchDocListsApi,
    UpdateStaffCodeApi,
    UpdateStaffJoinDateApi,
    CheckTokenExpApi,
    UpdateDocumentApi,
    CreateDocumentApi,
    CreateStaffFormApi,
    UpdateStaffFormApi,
    HandleSendEmailApi,
    GetStaffSignStatusApi,
  };
};

export default HttpClient;
